<div class="row justify-content-end">
  <label class="col fw-bold d-block my-auto">
    @if (props.required) {
      <span class="text-colour-red-600">
        *
      </span>
    }
    {{props.headerLabel}}
  </label>
  <div class="col d-flex justify-content-end">
    <button
      class="btn"
      [disabled]="props.disabled"
      [ngClass]="props.button.className ?? ''"
      [class.disabled]="formControl.disabled"
      [type]="props.button.type ?? 'button'"
      (click)="!props.button.onClick || props.button.onClick(field)"
    >
      @if (props.button.iconClass) {
        <i [ngClass]="props.button.iconClass"></i>
      }
      {{ props.button.label }}
    </button>
  </div>
</div>
